/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode.Byte"/>
define("SuiteCommerce.PagePrinter.ExtQRCode.Byte", ["require", "exports", "SuiteCommerce.PagePrinter.ExtQRCode.Utils"], function (require, exports, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Byte = /** @class */ (function () {
        function Byte(data) {
            this.mode = Utils_1.QRMode;
            this.data = data;
            this.parsedData = [];
            for (var i = 0; i < this.data.length; i++) {
                var byteArray = [];
                var code = this.data.charCodeAt(i);
                if (code > 0x10000) {
                    byteArray[0] = 0xf0 | ((code & 0x1c0000) >>> 18);
                    byteArray[1] = 0x80 | ((code & 0x3f000) >>> 12);
                    byteArray[2] = 0x80 | ((code & 0xfc0) >>> 6);
                    byteArray[3] = 0x80 | (code & 0x3f);
                }
                else if (code > 0x800) {
                    byteArray[0] = 0xe0 | ((code & 0xf000) >>> 12);
                    byteArray[1] = 0x80 | ((code & 0xfc0) >>> 6);
                    byteArray[2] = 0x80 | (code & 0x3f);
                }
                else if (code > 0x80) {
                    byteArray[0] = 0xc0 | ((code & 0x7c0) >>> 6);
                    byteArray[1] = 0x80 | (code & 0x3f);
                }
                else {
                    byteArray[0] = code;
                }
                this.parsedData.push(byteArray);
            }
            if (this.parsedData.length != this.data.length) {
                this.parsedData.unshift(191);
                this.parsedData.unshift(187);
                this.parsedData.unshift(239);
            }
        }
        Byte.prototype.length = function () {
            return this.parsedData.length;
        };
        Byte.prototype.write = function (buffer) {
            for (var i = 0; i < this.parsedData.length; i++) {
                buffer.put(this.parsedData[i], 8);
            }
        };
        return Byte;
    }());
    exports.Byte = Byte;
});
